import { Model } from "pinia-orm";
import ActivityNature from "./ActivityNature.js";

export default class Domain extends Model {
  static entity = "domains";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      code: this.string(""),
      internalCode: this.string(""),
      label: this.string(""),
      createdAt: this.string(""),
      updatedAt: this.string(""),

      activityNatureUuid: this.string(""),
      activityNature: this.belongsTo(ActivityNature, "activityNatureUuid"),
    };
  }
  static with = ["activityNature"];
}
